/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './silo-sensors-history.scss';

/* eslint-disable import/no-unresolved, import/default */

import siloSensorsHistoryTemplate from './silo-sensors-history.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siloSensorsHistory', [])
    .directive('agSiloSensorsHistory', SiloSensorsHistory)
    .name;

/*@ngInject*/
function SiloSensorsHistory() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SiloSensorsHistoryController,
        controllerAs: 'vm',
        templateUrl: siloSensorsHistoryTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SiloSensorsHistoryController($scope, $filter, $q, $translate, unitService, types, agTypes, agUtils, siloService, userService, entityService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.loading = false;

    vm.temperatureContent = true;
    vm.moistureContent = false;

    vm.extraSensorsObj = {
        cropLevel: false,
        headSpaceCo2Level: false,
        headSpaceTemperature: false,
        headSpaceDewpoint: false,
        headSpaceHumidity: false,
        headSpacePressure: false
    };

    let resetedExtraSensorsObj = angular.copy(vm.extraSensorsObj);

    vm.tempHistoryUnits = unitService.temperatureUnitSymbol();
    vm.flotKeySettings = {};

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.siloId = null;
    vm.silo = null;

    vm.helpPageAction = agUtils.createHelpActionConfig("agSilo", "ag.docsPageSections.silo-sensors-history");

    vm.isExtraSensorsSelected = isExtraSensorsSelected;
    vm.toggleAllExtraSensors = toggleAllExtraSensors;

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;

            vm.siloId = null;
            if (vm.ctx.stateController) {
                vm.siloId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSilo();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiloId, prevSiloId) {
                    if (newSiloId && !angular.equals(newSiloId, prevSiloId)) {
                        vm.siloId = newSiloId;
                        loadSilo();
                    }
                }
            );
        }
    });

    $scope.$watch(function() { return vm.silo ? (vm.silo.label || vm.silo.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = $translate.instant('ag.silo.silo-sensors-history') + ': ' + title;
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    function loadSilo() {
        vm.silo = null;
        vm.levelIndicator = null;
        vm.headSpaceSensor = null;
        reset();
        if (vm.siloId) {
            vm.loading = true;
            siloService.getSilo(vm.siloId).then(
                function success(silo) {
                    vm.silo = silo;
                    vm.extraSensorsObj = angular.copy(resetedExtraSensorsObj);
                    reloadSiloSensorLines().then(
                        (sensorLines) => {
                            vm.temperatureContent = true;
                            vm.moistureContent = false;
                            let extraSensorsTasks = [];
                            extraSensorsTasks.push(entityService.getRelatedEntities(vm.siloId, types.entityType.device, [agTypes.deviceType.levelIndicator], 1, [], agTypes.deviceTypeTranslatePrefix));
                            extraSensorsTasks.push(siloService.getSiloHeadSpaceSensor(vm.siloId));
                            $q.all(extraSensorsTasks).then(
                                (extraSensorsBody) => {
                                    vm.levelIndicator = extraSensorsBody[0][0];
                                    vm.headSpaceSensor = extraSensorsBody[1][0];
                                    updateSensors(sensorLines);
                                    vm.loading = false;
                                },
                                () => {
                                    updateSensors(sensorLines);
                                    vm.loading = false;
                                }
                            );
                        },
                        () => {
                            updateSensors([]);
                            vm.loading = false;
                        }
                    );
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function reset() {
    }

    function reloadSiloSensorLines() {
        var deferred = $q.defer();
        if (vm.siloId) {
            siloService.getSiloSensorLines(vm.siloId).then(
                function success(sensorLines) {
                    if (vm.silo) {
                        siloService.excludeUnconnectedSensorLines(sensorLines);
                        deferred.resolve(sensorLines);
                    }
                },
                function fail() {
                    deferred.reject();
                }
            );
        }
        return deferred.promise;
    }
    
    function updateSensors(sensorLines) {

        if (vm.selectedSensorLinesWatchHandle) {
            vm.selectedSensorLinesWatchHandle();
        }
        if (vm.selectedSensorsWatchHandle) {
            vm.selectedSensorsWatchHandle();
        }

        vm.sensorLines = $filter('orderBy')(sensorLines, agTypes.attributes.temperatureSensorLinesClient.lineNum);
        vm.selectedSensorLines = [];
        vm.selectedSiloSensors = [];
        var selectedLineNum = vm.ctx.selectedLineNum;
        var selectedSensorIndex = vm.ctx.selectedSensorIndex;
        var selectedSensorTelemetry = vm.ctx.selectedSensorTelemetry;
        delete vm.ctx.selectedLineNum;
        delete vm.ctx.selectedSensorIndex;
        delete vm.ctx.selectedSensorTelemetry;

        if (angular.isDefined(selectedSensorIndex) && angular.isDefined(selectedLineNum)) {
            vm.selectedSensor = {
                lineNum: selectedLineNum,
                index: selectedSensorIndex,
                telemetryType: selectedSensorTelemetry
            }
        }

        updateSubscriptions();

        vm.selectedSensorLinesWatchHandle = $scope.$watch('vm.selectedSensorLines',
            (newSelectedSensorLines, prevSelectedSensorLines) => {
                if (newSelectedSensorLines && !angular.equals(newSelectedSensorLines, prevSelectedSensorLines)) {
                    updateSubscriptions();
                }
            }, true);

        vm.selectedSensorsWatchHandle = $scope.$watch('vm.selectedSiloSensors',
            (newSelectedSensors, prevSelectedSensors) => {
                if (newSelectedSensors && !angular.equals(newSelectedSensors, prevSelectedSensors)) {
                    updateSubscriptions();
                }
            }, true);
    }

    $scope.$watch('vm.temperatureContent + vm.moistureContent', () => {
        if (vm.sensorLines && vm.sensorLines.length) {
            updateSubscriptions();
        }
    });

    $scope.$watch('vm.extraSensorsObj', (newValue, prevValue) => {
        if (!angular.equals(newValue, prevValue)) {
            updateSubscriptions();
        }
    }, true);

    function updateSubscriptions() {
        vm.siloSensorsHistorySubscriptionsInfo = [];
        vm.sensorLines.forEach((sensorLine) => {
            var selectedSensorLine = $filter('filter')(vm.selectedSensorLines, {lineNum: sensorLine.lineNum}, true);
            if (selectedSensorLine && selectedSensorLine.length) {
                var selectedSensorLineSensors = $filter('filter')(vm.selectedSiloSensors, {lineNum: sensorLine.lineNum}, true);
                if (selectedSensorLineSensors && selectedSensorLineSensors.length) {
                    vm.siloSensorsHistorySubscriptionsInfo.push(createTelemetrySubscriptionInfoFromSensorLine(sensorLine, selectedSensorLineSensors));
                }
            }
        });
        if (vm.headSpaceSensor) {
            for (let prop in vm.extraSensorsObj) {
                if (vm.extraSensorsObj[prop] && prop.startsWith("headSpace")) {
                    vm.siloSensorsHistorySubscriptionsInfo.push(createHeadSpaceSubscriptionInfo(prop));
                }
            }
        }
        if (vm.extraSensorsObj.cropLevel) {
            vm.siloSensorsHistorySubscriptionsInfo.push(createCropLevelSubscriptionInfo());
        }
    }

    function createTelemetrySubscriptionInfoFromSensorLine(sensorLine, selectedSensorLineSensors) {
        var subscriptionInfo = {
            type: types.datasourceType.entity,
            entityType: types.entityType.device,
            entityId: sensorLine.id.id,
            entityName: sensorLine.name,
            timeseries: []
        };
        for (var i=0;i<sensorLine.sensorCount;i++) {
            var selectedSensorLineSensor = $filter('filter')(selectedSensorLineSensors, {index: i}, true);
            if (selectedSensorLineSensor && selectedSensorLineSensor.length) {
                if (vm.temperatureContent) {
                    var timeseriesTemperatureKey = {
                        name: agTypes.telemetry.sensorLines.temperaturePrefix + (i + 1),
                        label: $translate.instant('ag.silo.cable') + ' ' + sensorLine.lineNum + ': '
                        + $translate.instant('ag.silo.temperature') + ' ' + (i + 1),
                        postFuncBody: unitService.temperaturePostprocessingFuncBody()
                    };
                    subscriptionInfo.timeseries.push(timeseriesTemperatureKey);
                }
                if (vm.moistureContent && selectedSensorLineSensor[0].isMoisture) {
                    var timeseriesMoistureKey = {
                        name: agTypes.telemetry.sensorLines.moisturePrefix + (i + 1),
                        label: $translate.instant('ag.silo.cable') + ' ' + sensorLine.lineNum + ': '
                        + $translate.instant('ag.silo.moisture') + ' ' + (i + 1),
                    };
                    subscriptionInfo.timeseries.push(timeseriesMoistureKey);
                }
            }
        }
        return subscriptionInfo;
    }

    function createCropLevelSubscriptionInfo() {
        var subscriptionInfo = {
            type: types.datasourceType.entity,
            entityType: types.entityType.asset,
            entityId: vm.silo.id.id,
            entityName: vm.silo.name,
            timeseries: [
                { name: agTypes.telemetry.silo.cropLevelMin, label: "Min Level" },
                { name: agTypes.telemetry.silo.cropLevelAvg, label: "Avg Level" },
                { name: agTypes.telemetry.silo.cropLevelMax, label: "Max Level" }
            ]
        };
        /*var cropLevelKey = {
            name: agTypes.telemetry.levelIndicator.cropLevelPrefix + 1,
            label: $translate.instant('ag.silo.crop-level'),
        };*/
        //subscriptionInfo.timeseries.push(cropLevelKey);
        return subscriptionInfo;
    }

    function createHeadSpaceSubscriptionInfo(property) {
        var subscriptionInfo = {
            type: types.datasourceType.entity,
            entityType: types.entityType.device,
            entityId: vm.headSpaceSensor.id.id,
            entityName: vm.headSpaceSensor.name,
            timeseries: []
        };
        var headSpaceKey = {};
        if (property === "headSpaceTemperature") {
            headSpaceKey.name = agTypes.telemetry.headSpaceSensor.temperature;
            headSpaceKey.label = $translate.instant('ag.silo.check-head-space-temperature');
            headSpaceKey.postFuncBody = unitService.temperaturePostprocessingFuncBody();
        } else if (property === "headSpaceDewpoint") {
            headSpaceKey.name = agTypes.telemetry.headSpaceSensor.dewpoint;
            headSpaceKey.label = $translate.instant('ag.silo.check-head-space-dewpoint');
            headSpaceKey.postFuncBody = unitService.temperaturePostprocessingFuncBody();
        } else if (property === "headSpaceCo2Level") {
            headSpaceKey.name = agTypes.telemetry.headSpaceSensor.co2level;
            headSpaceKey.label = $translate.instant('ag.silo.check-head-space-co2level');
        } else if (property === "headSpaceHumidity") {
            headSpaceKey.name = agTypes.telemetry.headSpaceSensor.humidity;
            headSpaceKey.label = $translate.instant('ag.silo.check-head-space-humidity');
        } else if (property === "headSpacePressure") {
            headSpaceKey.name = agTypes.telemetry.headSpaceSensor.pressure;
            headSpaceKey.label = $translate.instant('ag.silo.check-head-space-pressure');
        }
        subscriptionInfo.timeseries.push(headSpaceKey);
        return subscriptionInfo;
    }

    function isExtraSensorsSelected() {
        let flag;
        for (let prop in vm.extraSensorsObj) {
            if (vm.extraSensorsObj[prop]) {
                flag = true;
            }
        }
        return flag;
    }

    function toggleAllExtraSensors(action) {
        if (vm.headSpaceSensor) {
            for (let prop in vm.extraSensorsObj) {
                if (prop.startsWith("headSpace")) {
                    vm.extraSensorsObj[prop] = (action && action === "select");
                }
            }
        }
        if (vm.levelIndicator) {
            vm.extraSensorsObj.cropLevel = (action && action === "select");
        }
    }
}